"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.useViewMeta = exports.pickViewProperty = void 0;
const core_1 = require("../core");
const model_1 = require("../model");
const use_views_1 = require("./private/use_views");
/** @internal */
const pickViewProperty = (view) => {
    return {
        id: view.id,
        type: (0, core_1.getViewTypeString)(view.type),
        name: view.name,
        hidden: view.hidden,
        groupInfo: view.groupInfo,
        filterInfo: view.filterInfo,
        sortInfo: view.sortInfo,
    };
};
exports.pickViewProperty = pickViewProperty;
function useViewMeta(param1, param2) {
    const isDatasheet = param1 instanceof model_1.Datasheet;
    const datasheetId = isDatasheet ? param1.datasheetId : undefined;
    const viewId = (isDatasheet ? param2 : param1);
    const viewsData = (0, use_views_1.useViews)(datasheetId);
    const view = viewsData.find(view => view.id === viewId);
    if (!view) {
        return undefined;
    }
    return (0, exports.pickViewProperty)(view);
}
exports.useViewMeta = useViewMeta;
